import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/cash_flow/transactions_additional_details/download";

export class DownloadTransactionAdditionalDetailsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any = null;

    constructor(transactionId: string, exportType: string) {
        super();
        this.params = { exportType, transactionId };
        this.responseType = "text";
    }

    public async execute(): Promise<AxiosResponse> {
        console.log("DownloadInstallationsEnabledModulesCommand.execute()", this.params);
        return await this.executeCommand(null, null, this.params);
    }
}
